import React from "react";
import { useLocation } from "react-router-dom";
import { makePost } from "@culturehq/client";
import { Grid, Panel, Spinner, Success } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { parseQueryString, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";

const SlackLink: React.FC = () => {
  const location = useLocation();
  const { id: slackUserId } = parseQueryString(location.search);

  const { error, fetching } = useFetch(
    () => makePost("/slack/link", { slackUserId }),
    [slackUserId]
  );

  return (
    <Grid>
      <Grid.Item sm={4} />
      <Grid.Item sm={4}>
        {fetching && (
          <Panel>
            <Panel.Body>
              <Trans>Linking your Slack account...</Trans>
              <Spinner />
            </Panel.Body>
          </Panel>
        )}
        {error && (
          <ErrorMessage error={error} />
        )}
        {!fetching && !error && (
          <Success>
            <Trans>Successfully linked your Slack account.</Trans>
          </Success>
        )}
      </Grid.Item>
    </Grid>
  );
};

export default SlackLink;
